import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectCsvMappingsProperties = createSelector(
  getCompany,
  ({ csvMappingsProperties }) => csvMappingsProperties,
);
